import { Box, Typography } from '@mui/material'
import wordmark from '~/assets/transparent-wordmark.png'
import { ParallaxHero } from '../_components/parallax-hero'

export const HeroSection = () => (
  <ParallaxHero>
    <Box
      component="img"
      src={wordmark}
      alt="TerraPlanner"
      width={200}
      height={50}
      sx={{ height: { xs: 56, md: 72 }, width: 'auto', mb: 1 }}
    />

    <Typography
      component="h1"
      variant="h5"
      fontWeight={400}
      sx={{ maxWidth: 640, mx: 'auto', mb: 3, opacity: 0.92, lineHeight: 1.5, fontSize: { xs: '1.1rem', md: '1.35rem' } }}
    >
      Growing farms with intelligence.
    </Typography>

    <Typography
      variant="body1"
      sx={{ maxWidth: 580, mx: 'auto', opacity: 0.78, lineHeight: 1.75, fontSize: { xs: '0.95rem', md: '1rem' } }}
    >
      TerraPlanner is a climate-aware crop scheduling tool built for everyday farmers and homesteaders.
      It combines real frost data, seasonal rhythms, and your specific crops into a single living plan —
      so you spend less time guessing and more time growing.
    </Typography>
  </ParallaxHero>
)
